import _ from 'lodash';
import * as adapi from '~/utils/adapi';
import { mapGetters, mapState } from 'vuex';
import { STATUSES } from '~/utils/constants';
import * as permissions from '~/utils/permissions';

export default {
  data() {
    return {
      code: null,
      loading: false,
    };
  },
  computed: {
    ...mapState('genericConfig', ['config']),
    ...mapGetters('campaign', { campaign: 'currentCampaign' }),
    permissions() {
      return permissions.getPermissions(this.campaign);
    },
    creativeRefresh() {
      const current = this.getCampaignDetail('timesUsedCreativeRefresh', 0);
      let max = 0;
      // TODO: probably we should get this data directly from FAM,
      // to be sure that we calculate it equally on both sides
      if (_.get(this.config, 'creative_refresh_settings.is_scheduled_refresh', false)) {
        max = _.get(this.config, 'creative_refresh_settings.scheduled_refresh_months', 0);
      } else if (_.get(this.config, 'creative_refresh_settings.is_on_demand_refresh', false)) {
        max = this.getCampaignDetail('creativeRefreshCount', 0);
      }
      return { current, max };
    },
    showComponent() {
      return this.campaign.baseStatus.code === STATUSES.ONL
        && this.permissions.includes('viewCreativeRefresh')
        && this.creativeRefresh.max > 0;
    },
  },
  methods: {
    refreshCreative() {
      this.loading = true;
      this.$refs.modal.hide();
      return adapi.post(`campaigns/${this.campaign.code}/refresh-creative`)
        .then(result => {
          this.loading = false;
          this.$toast.success({
            message: this.$t('pos.campaign.creative-added'),
          });
          this.$router.push({
            name: 'creative',
            params: {
              id: result,
            },
          });
        })
        .catch(e => {
          this.$toast.error({ message: e.toString() });
          this.loading = false;
        });
    },
    getCampaignDetail(name, defaultValue = null) {
      const detail = _.has(this.campaign, 'details') && this.campaign.details.find(d => d.name === name);
      return detail ? detail.value : defaultValue;
    },
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/creative-refresh/CreativeRefresh.js